import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { OrderDetails } from "src/slices/orders/types";
import { format } from "date-fns";

interface InvoiceProps {
  open: boolean;
  handleClose: () => void;
  order_created: OrderDetails | null;
}

const Invoice: React.FC<InvoiceProps> = ({
  order_created,
  open,
  handleClose,
}) => {
  // eslint-disable-next-line
  const invoiceRef = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line
  const [order, setorder] = useState<OrderDetails | null>(null);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [discountedPrice, setDiscountedPrice] = useState<number>(0);

  useEffect(() => {
    if (order_created) {
      setorder({ ...order_created });
      const total = order_created?.servicesItems?.reduce(
        (old, current) => old + +current.price * +current.estimatedNumOfItems,
        0
      );
      setTotalPrice(total || 0);
      // setDiscountedPrice(total>=3000? 0 : 210);
    }
  }, [order_created]);

  // console.log(order);

  const handlePrint = () => {
    const printWindow = window.open("", "", "width=400,height=600");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Invoice</title>
            <style>
              body {
                width: 78mm;
                margin: 0;
                padding: 0;
                font-family: monospace;
                font-size: 12px;
              }
            </style>
          </head>
          <body>
            ${invoiceRef.current.innerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      alert("Please allow pop-ups to print the invoice.");
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <div ref={invoiceRef}>
          <div
            style={{
              width: "78mm",
              fontFamily: "Arial, sans-serif",
              fontSize: "10px",
              padding: "10px",
            }}
          >
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <img
                src="/invoice-logo.png"
                alt="Laundry Xpress Logo"
                style={{ width: "70px", height: "24px" }}
              />
              <h2 style={{ fontSize: "14px", margin: "5px 0" }}>
                Laundry Xpress
              </h2>
            </div>

            <p><strong>Order#: LX-{order?.id}</strong></p>
            <p><strong>Customer Name:</strong> {order?.customerName}</p>
            {/* <p><strong>Date & Time:</strong> {format(new Date(order?.createdAt), "YYYY-MM-dd")}</p> */}
            {order?.createdAt && <p><strong>Date & Time:</strong> {format(new Date(order?.createdAt), 'dd/MM/yy HH:mm:ss')}</p>}

            <hr style={{ margin: "10px 0" }} />

            <table
              style={{ width: "100%", textAlign: "left", fontSize: "10px" }}
            >
              <thead>
                <tr>
                  <th>Service</th>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {order?.servicesItems?.map((item, index) => (
                  <tr key={index}>
                    <td>{item?.serviceName}</td>
                    <td>{item?.itemName}</td>
                    <td>{item.estimatedNumOfItems}</td>
                    <td>{item?.price}</td>
                    <td>
                      {(+item.estimatedNumOfItems * +item.price).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <p style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
              <strong>Total QTY:</strong>{" "}
              <strong>{order?.servicesItems?.reduce(
                (old, current) => old + Number(current.estimatedNumOfItems),
                0
              )}</strong>
            </p>

            <hr style={{ margin: "10px 0" }} />

            <div style={{ textAlign: "left", fontSize: "10px" }}>
              <p style={{display: "flex", justifyContent: "space-between"}}>
                <strong>Sub Total:</strong> RS {totalPrice.toFixed(2)}
              </p>
              <p style={{display: "flex", justifyContent: "space-between"}}>
                <strong>Discount:</strong> 0
              </p>
              {/* <p style={{display: "flex", justifyContent: "space-between"}}>
                <strong>Delivery Charges:</strong> RS {discountedPrice.toFixed(2)}
              </p> */}
              <p style={{display: "flex", justifyContent: "space-between"}}>
                <strong>Total:</strong>
                <strong>RS {(totalPrice + discountedPrice).toFixed(2)}</strong>
              </p>
            </div>

            <hr style={{ margin: "10px 0" }} />

            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                margin: "10px 0",
              }}
            >
              THANKS FOR THE VISIT!
            </div>

            <h3 style={{ fontSize: "12px", marginBottom: "5px" }}>
              Terms and Conditions
            </h3>
            <div>
              <strong>1-</strong> We are not responsible for color change if the fabric releases
              its own color and damages your fabric.
            </div>
            <div>
            <strong>2-</strong> Before handing over the clothes, please check the pockets for
              personal belongings.
            </div>
            <div>
            <strong>3-</strong> Any issue with respect to quality has to be reported to us
              within 24-48 hours of drop-off.
            </div>
            <div>
            <strong>4-</strong> Items will not be handed over until payment against the order
              is cleared.
            </div>

            <div style={{ marginTop: "20px", fontSize: "10px", display: "flex", flexDirection: "column", gap: "5px" }}>
              <div>
                <strong>NTN:</strong> 4923372-8
              </div>
              <div>
                <strong>Cashier Name:</strong> {order?.cashierName || "N/A"}
              </div>
              <div>
                Shop no G3 Mateen Mall Opposite NED University,
                <br /> Gulistan e Johar Block 1 Karachi
              </div>
              <div>
                <strong>Contact:</strong> 03122946615
              </div>
            </div>

            <hr style={{ margin: "10px 0" }} />

            <div style={{ textAlign: "center", fontSize: "9px" }}>
              Designed and Developed by Stifftech
              <br />
              <a href="https://www.stifftech.com" target="_blank" rel="noopener noreferrer">
                www.stifftech.com
              </a>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handlePrint}>Print</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Invoice;
